import classNames from "classnames";
import PhoneInput2 from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./stlyle.scss";

interface Props {
  className?: string;
  value: string;
  onChange(value: string): void;
  placeholder?: string;
}

export const PhoneInput = ({
  value,
  onChange,
  className,
  placeholder,
}: Props) => {
  return (
    <PhoneInput2
      country={"us"}
      value={value}
      onChange={(value: string) => onChange("+" + value)}
      containerClass={classNames("phone-input-container", className)}
      inputClass="phone-input-control"
      placeholder={placeholder}
    />
  );
};
